import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocStep } from '../shared/DocStep'

const Embeds = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Presentation Embeds let you showcase a Presentation on your own website,
        blog, or conference page. The embed displays the Presentation title,
        presenter name, description, and a link back to the full Presentation
        page on Guild — giving external visitors a preview of the talk without
        leaving your site.
      </Paragraph>
      <Paragraph size='$5'>
        Embeds are lightweight widgets that load inside an iframe, so they work
        on any website regardless of framework or CMS. The styling is
        self-contained and automatically adapts to light and dark backgrounds.
      </Paragraph>
      {/* TODO: Capture screenshot of Presentation page → Share/Embed dialog showing the presentation embed code */}
    </Card>

    <Card gap='$4'>
      <DocSection id='getting-embed-code' title='Getting the Embed Code'>
        <Paragraph size='$5'>
          To embed a Presentation on an external site, follow these steps.
        </Paragraph>
        <DocStep
          number={1}
          title='Open the Presentation page'
          description='Navigate to the Presentation you want to embed. You can find it through your profile, a Guild page, or by searching for it in the Command Palette.'
        />
        <DocStep
          number={2}
          title='Open the share menu'
          description='Click the Share button on the Presentation page to reveal sharing options, including the embed code.'
        />
        <DocStep
          number={3}
          title='Copy the embed code'
          description='Copy the provided HTML snippet. It includes a script tag and a container element that renders the Presentation widget on your site.'
        />
        <DocStep
          number={4}
          title='Paste into your site'
          description='Add the embed code to any HTML page, blog post, or CMS content block. The widget loads automatically and links back to the full Presentation on Guild.'
        />
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='embed-use-cases' title='When to Use Presentation Embeds'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='globe' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Conference websites</Paragraph> — Highlight
              speaker talks on your event's website with a live preview that stays up to date.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='edit' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Company blogs</Paragraph> — Feature team
              members' Presentations in blog posts or internal knowledge bases.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='person' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Personal portfolios</Paragraph> — Showcase
              your speaking history on your personal site with embeds that link back to the full
              Presentation on Guild.
            </Paragraph>
          </XStack>
        </YStack>
        <Paragraph size='$5'>
          Any updates to the title, description, or video are reflected
          automatically in the embed. For embedding an entire Guild or its
          Events, see{' '}
          <Link href='/docs/guilds/embeds'>Guild Embeds</Link> and{' '}
          <Link href='/docs/events/embeds'>Event Embeds</Link>.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default Embeds
